module.exports = __webpack_public_path__ + "static/img/10020.89f83175.png";